<template>
  <div class="q-gutter-md">
    <create-search-btn :client-id="clientId" @created="prepend" />
    <post-searches-table :client-id="clientId" ref="searches" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CreateSearchBtn from '@/social/post/search/CreateSearchBtn.vue';
import { PostSearch, List } from '@/type';
import PostSearchesTable from './PostSearchesTable.vue';

export default defineComponent({
  components: { CreateSearchBtn, PostSearchesTable },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    prepend(postSearch: PostSearch) {
      (this.$refs.searches as List).prepend(postSearch);
    },
  },
});
</script>
